import { Spinner } from '../Spinner';

export const PageSpinner = () => (
  <div className="flex w-full h-full justify-center items-center">
    <Spinner size={40} />
  </div>
);
